import { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Chip from '@material-ui/core/Chip';
import hexRgba from 'hex-rgba';
import { withStyles } from '@material-ui/core/styles';
import ImageDisplay from './ImageDisplay';
import { color as themeColor } from '../../app/theme';
import icZap from '../../assets/images/svg/ic-zap.svg';
import tagAdd from '../../assets/images/svg/ic-add-circle-20.svg';
import tagDelete from '../../assets/images/svg/ic-x-circle-20.svg';

const useStyles = theme => ({
  root: {
    ...theme.chip.root,
    maxWidth: '100%',
  },
  tagStyle: {
    height: 24,
    fontSize: 13,
    color: themeColor.$7,
    padding: '0px 12px',
    margin: '0 5px',
  },
  'tagStyle--size-m': {
    height: 32,
    fontSize: 15,
  },
  'tagStyle--with-icon': {
    padding: '0px 12px 0px 8px',
  },
  tagStyleClickable: {
    padding: '0px 6px 0 12px',
  },
  'tagStyleClickable--size-m': {
    padding: '9px 6px 8px 12px',
  },
  label: theme.chip.label,
  deleteIcon: {
    width: 20,
    height: 20,
    margin: 0,
  },
  colorPrimary: theme.chip.colorPrimary,
  colorSecondary: theme.chip.colorSecondary,
  black: theme.chip.black,
  basicDisable: {
    ...theme.chip.colorPrimary,
    backgroundColor: themeColor.$9,
    '&:hover, &:focus': {},
  },
  red: {
    backgroundColor: themeColor.$17,
    '&:hover, &:focus': {
      backgroundColor: '#CC4E43',
    },
  },
  transPrimary: {
    ...theme.typography.body1,
    color: themeColor.$2,
    padding: '6px 7px 5px 8px',
    backgroundColor: hexRgba(themeColor.$1, 10),
  },
  transSecondary: {
    ...theme.typography.body1,
    color: themeColor.$18,
    padding: '6px 7px 5px 8px',
    backgroundColor: hexRgba(themeColor.$16, 10),
  },
  blue: {
    ...theme.typography.body1,
    color: themeColor.$7,
    backgroundColor: themeColor.$15,
    '&:hover': {
      backgroundColor: '#177e8f',
    },
  },
  icon: { objectFit: 'contain', cursor: 'pointer', margin: '0 2px 0 0' },
  'icon--clickable': {
    margin: '0 0 0 2px',
  },
  'icon--size-m': {
    width: 24,
    height: 24,
  },
  index: {
    borderRadius: 20,
    background: themeColor.$6,
    color: themeColor.$7,
    fontSize: '13px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1',
    letterSpacing: 'normal',
    textAlign: 'center',
    height: 20,
    padding: '4px 8px',
  },
});

class Tag extends Component {
  handleClickIcon = e => {
    e.stopPropagation();
    const {
      tag,
      idx,
      conditionIndex,
      addable,
      deleteable,
      onClickFunction,
      onDeleteFunction,
      isCondition,
    } = this.props;
    if (addable) {
      onClickFunction(tag);
    }
    if (deleteable) {
      if (isCondition) {
        onDeleteFunction(conditionIndex, idx);
      } else {
        onDeleteFunction(tag);
      }
    }
  };

  render() {
    const {
      classes,
      tag,
      color,
      addable,
      className,
      clickable,
      style,
      iconStyle,
      icon,
      size,
      isShowDelete,
      onClick,
      isIndex,
    } = this.props;
    if (!clickable) {
      return (
        <Chip
          classes={{
            root: classes.root,
            label: classes.label,
          }}
          label={<span title={tag}>{tag}</span>}
          icon={
            icon && (
              <img
                className={classes.icon}
                alt={tag}
                src={icon}
                width={15}
                height={15}
              />
            )
          }
          onClick={onClick}
          className={classnames([classes.tagStyle, classes[color], className], {
            [classes['tagStyle--size-m']]: size === 'M',
            [classes['tagStyle--with-icon']]:
              icon !== null && icon !== undefined,
          })}
          style={style}
        />
      );
    }
    return (
      <Chip
        classes={{
          root: classes.root,
          label: classes.label,
          deleteIcon: classnames(
            classes.deleteIcon,
            classes['icon--clickable'],
            iconStyle,
          ),
        }}
        label={
          <span style={!isShowDelete ? { paddingRight: 6 } : null} title={tag}>
            {isIndex ? <div className={classes.index}>{tag}</div> : tag}
          </span>
        }
        icon={
          this.props.icon && (
            <ImageDisplay alt={tag} className={classes.icon} src={icZap} />
          )
        }
        onClick={onClick}
        onDelete={isShowDelete ? this.handleClickIcon : null}
        className={classnames(
          classes.tagStyle,
          classes.tagStyleClickable,
          classes[color],
          className,
          {
            [classes['tagStyle--size-m']]: size === 'M',
            [classes['tagStyleClickable--size-m']]: size === 'M',
          },
        )}
        clickable={onClick ? clickable : null}
        deleteIcon={
          <ImageDisplay
            alt={tag}
            className={classnames(classes.icon, {
              [classes['icon--size-m']]: size === 'M',
            })}
            src={addable ? tagAdd : tagDelete}
          />
        }
      />
    );
  }
}

Tag.defaultProps = {
  size: 'S',
  isShowDelete: true,
};

Tag.propTypes = {
  size: PropTypes.oneOf(['S', 'M']),
  isShowDelete: PropTypes.bool,
};

export default withStyles(useStyles)(Tag);
